import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { BaseService } from 'src/app/_services/base.service';
import { environment } from 'src/environments/environment';

export type StoreOverviewDateRange = 'Today' | 'Yesterday' | 'ThisWeek' | 'ThisMonth' | 'Custom';

export interface StoreOverviewRequest {
    locationIds: string[];
    dateRange: StoreOverviewDateRange;
    startDate?: string | null;
    endDate?: string | null;
    categoryIds?: string[];
    productIds?: string[];
    topProductsCount?: number;
    timeZone?: string | null;
}

@Injectable({
    providedIn: 'root'
})
export class StoreOverviewReportService {

    constructor(private _bs: BaseService) { }

    /** POST {InventoryBaseURL}Reports/GetStoreOverview */
    getStoreOverview(body: StoreOverviewRequest) {
        const url = environment.InventoryBaseURL + 'Reports/GetStoreOverview';
        return this._bs.httpPost(url, JSON.stringify(body)).pipe(map((res: any) => res));
    }
}
